"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = floatingAlertMiddleware;

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _Constants = require("FileManagerCore/Constants");

function floatingAlertMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        if (!action.meta || !action.meta[_Constants.NOTIFICATION_EVENT]) {
          return next(action);
        }

        var payload = action.meta[_Constants.NOTIFICATION_EVENT];

        _FloatingAlertStore.default.addAlert(payload);

        return next(action);
      };
    };
  };
}

module.exports = exports.default;